export default {"src":"/_next/static/media/apex.23435e8c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};